import { Text, StyleSheet, Image, View } from '@react-pdf/renderer';
import { formatDateToString } from '@/helpers';
import strings from '@/language/Swedish';
import LogoImage from '@/assets/images/pdf/logo.png';

interface FooterProps {
  username: string;
  hideClientData?: boolean;
}
const Footer = ({ username, hideClientData }: FooterProps) => {
  const styles = StyleSheet.create({
    wrapper: {
      dispay: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: "100%",
      zIndex: 0,
      paddingLeft: '6mm',
      paddingRight: '6mm',
      position: "absolute",
      left: 0,
      bottom: 5,
      backgroundColor: "white"
    },
    text: { fontFamily: 'Chivo', fontSize: 9, opacity: 0.5 },
    image: { height: '20px', paddingBottom: 5 },
  });
  return (
    <View style={styles.wrapper}>
      <Text style={styles.text}>
        {hideClientData
          ? strings.report.licenceText1.replace('@username', username || '').replace("@date", formatDateToString(new Date()))
          : strings.report.licenceText2.replace('@username', username || '').replace("@date", formatDateToString(new Date()))
        }
      </Text>
      <Image src={LogoImage} style={styles.image} />
    </View>
  );
};

export default Footer;
